import { useEffect, useRef, useState } from 'react';

type StatItem = {
  value: string;
  label: string;
  sub: string;
  icon: string;
};

const stats: StatItem[] = [
  {
    value: '60%',
    label: 'Reduction in Operational Costs',
    sub: 'Across active client engagements within the first 90 days',
    icon: 'savings',
  },
  {
    value: '2-3',
    label: 'Weeks to First Automation',
    sub: 'From discovery call to a live, working system in production',
    icon: 'rocket_launch',
  },
  {
    value: '85%',
    label: 'Tasks Automated on Average',
    sub: 'Repetitive workflows handed off so your team focuses on what matters',
    icon: 'precision_manufacturing',
  },
  {
    value: '40+',
    label: 'Integrations Supported',
    sub: 'From CRMs and help desks to calendars, spreadsheets, and ERPs',
    icon: 'hub',
  },
  {
    value: '15+',
    label: 'Hours Saved per Week',
    sub: 'Per employee on average — time given back to strategy and growth',
    icon: 'schedule',
  },
  {
    value: '60',
    label: 'Days to ROI',
    sub: 'Most clients recoup their investment within two months of delivery',
    icon: 'trending_up',
  },
];

export function StatsBand() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="stats" className="section stats-band-section">
      <div className="container">
        <div className="section-header stats-header">
          <span className="eyebrow">By the Numbers</span>
          <h2>Automation that moves the needle</h2>
          <p>
            Real outcomes from real engagements. These are the numbers our clients report after
            working with Bizi Office — not projections, not promises.
          </p>
        </div>
        <div ref={ref} className={`stats-band-grid${visible ? ' is-visible' : ''}`}>
          {stats.map((stat, i) => (
            <div
              className="stat-band-item"
              style={{ transitionDelay: `${i * 80}ms` }}
              key={stat.label}
            >
              <div className="stat-band-icon">
                <span className="material-symbols-outlined">{stat.icon}</span>
              </div>
              <div className="stat-band-value">{stat.value}</div>
              <div className="stat-band-label">{stat.label}</div>
              <div className="stat-band-sub">{stat.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
